var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23844 4.46198V15.4994H8.84786e-07L9.23844 4.46198ZM9.23844 0.500618C9.24 3.02618 7.17156 5.07428 4.61906 5.07428C2.06656 5.07428 -0.00156162 3.02556 8.84786e-07 0.5L9.23844 0.500618ZM10.7603 15.5C10.7603 12.9754 12.8284 10.9288 15.3797 10.9288C17.9309 10.9288 19.9991 12.9754 19.9991 15.5H10.7603ZM10.7603 11.5386V0.5H20L10.7603 11.5386Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/customer-support.334347d7f73c177c87c87f074f0781ee.svg";
export { ForwardRef as ReactComponent };